export const BASE_URL_MAP = {
  SUPER_ADMINISTRATION: "superAdministration",
  BUSINESS_UNITS: "businessUnits",
  ORGANIZATIONS: "organizations",
};
export const DONNUT_FONT_FAMILY = "Montserrat";
export const FILTER_DATE_FORMAT = "YYYY-MM-DD";

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_FIRST_PAGE = 1;
export const FILTER_SEARCH_TXT_MIN_LENGTH = 3;
export const VALIDATION_REGEXP: Record<string, RegExp> = {
  // Match characters, number, underscores hyphens or spaces, but not only spaces
  CERTIFICATE_ALIAS: /^(?!\s*$)([a-z0-9\-_\s]*$)/g,

  // Email
  EMAIL: /^[a-zA-Z0-9.!#$%&’*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,

  // Forbid uppercase
  NO_UPPERCASE: /^[^A-Z]*$/,

  // Must contain lowercase + uppercase letters, number and special characters, minimum size should be 12 characters
  PASSWORD: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{12,}$/,

  // Alphabetical (with or without accent), numerical and space characters, special characters authorized except at the beginning or the end
  NAME: /^[a-zA-ZÀ-ÿ0-9]([a-zA-ZÀ-ÿ0-9 \-_.']*[a-zA-ZÀ-ÿ0-9])?$/,

  // Alphabetical lower-case (with or without accent), numerical, special characters authorized except at the beginning or the end
  LOGIN: /^[a-zà-ü0-9][a-zà-ü0-9!$%&'*+=?^`{|}~@_.-]*[a-zà-ü0-9]$/,

  // Extended ASCII characters
  // eslint-disable-next-line no-control-regex
  ASCII_EXTENDED: /^[\x00-\xFF]+$/,
};

export const DEFAULT_SORT_CONTENT_RESOURCE = "-modifiedAt";

/**
 * Key used to ask distinct values from the backend in
 * query params
 */
export const DISTINCT_VALUES_KEY = "distinctValues";

// Explode this object into typescript object if needed. This config is specific to the Chart.js zoom plugin.
// Check this resource for more details: https://www.chartjs.org/chartjs-plugin-zoom/latest/guide/options.html
export const DEFAULT_CHARTJS_ZOOM_SUB_CONFIG: any = {
  wheel: {
    enabled: true,
  },
  pinch: {
    enabled: true,
  },
  drag: {
    enabled: true,
  },
  mode: "x",
};

export const APP_NAME = "Lx Connect";

export const VALIDATION_NUMBER: Record<string, number> = {
  ALIAS_MAX_LENGTH: 50,
  MAIL_MAX_LENGTH: 255,
};

export const BANNER_CONTAINER_ID = "banner-container";
